<template>
  <section class="section page__content">
    <div class="info">
      <h2 class="subtitle info__title">Основная информация</h2>

      <ul class="info__list-edit info__list-edit--col-2 after-line after-line--edit">

        <PtoInfoItem
          label-text="Стройка"
          :text="currentProject.building ? currentProject.building.name : '-'"
        />

        <PtoInfoItem
          label-text="№ изменения"
          :text="currentProject.changes ? currentProject.changes[currentProject.changes.length - 1].number ? currentProject.changes[currentProject.changes.length - 1].number : '-' : '-'"
        />

        <PtoInfoItem
          label-text="Объект"
          :text="currentProject.object ? currentProject.object && currentProject.object.name : '-'"
        />

        <PtoInfoItem
          label-text="Дата создания изменений"
          :text="currentProject.changes ? currentProject.changes[currentProject.changes.length - 1].receive_date ? currentProject.changes[currentProject.changes.length - 1].receive_date : '-' : '-' "
        />
        
        <PtoInfoItem
          label-text="Дата начала"
          :text="currentProject.start_date ? currentProject.start_date : '-'"
        />

        <PtoInfoItem
          label-text="№ сметы"
          :text="currentProject.estimates ? currentProject.estimates[currentProject.estimates.length - 1].estimate ? currentProject.estimates[currentProject.estimates.length - 1].estimate : '-' : '-' "
        />
        
        <PtoInfoItem
          label-text="Дата окончания"
          :text="currentProject.stop_date ? currentProject.stop_date : '-'"
        />

        <PtoInfoItem
          label-text="Дата получения сметы"
          :text="currentProject.estimates ? currentProject.estimates[currentProject.estimates.length - 1].receive_date ? currentProject.estimates[currentProject.estimates.length - 1].receive_date : '-' : '-'"
        />

        <PtoInfoItem
          label-text="Ответственный сметный"
          :text="currentProject.object ? currentProject.object.estimate_responsible ? getUserFullName(currentProject.object.estimate_responsible) : '-' : '-'"
        />

        <PtoInfoItem
          label-text="% к Ген. подряд"
          text="-"
        />

        <PtoInfoItem
          label-text="Ген. подрядчик"
          :text="currentProject.general_contractor ? currentProject.general_contractor && currentProject.general_contractor.long_name : '-'"
        />

        <PtoInfoItem
          label-text="Сумма к Ген. подряд"
          text="-"
        />
      </ul>
      <PtoPriceInfoList :data="currentProject" />
    </div>

    <div v-if="!isEdit" class="info">
      <ul class="info__list-edit info__list-edit--col-2 after-line after-line--edit">
        <PtoInfoItem
          label-text="Шифр проекта"
          :text="currentProject.project_cipher ? currentProject.project_cipher : '-'"
        />

        <PtoInfoItem
          label-text="Дата получения"
          :text="currentProject.receive_date ? currentProject.receive_date : '-'"
        />

        <PtoInfoItem
          label-text="Статус"
          :text="currentProject.status ? currentProject.status && currentProject.status.name : '-'"
        />

        <PtoInfoItem
          label-text="Ответственный ПТО"
          :text="currentProject.pto_responsible ? getUserFullName(currentProject.pto_responsible) : '-'"
        />

        <PtoInfoItem
          label-text="Соисполнитель ПТО"
          :text="textCoExecutors ? textCoExecutors : '-'"
        />

        <PtoInfoItem
          label-text="ИД"
          :text="currentProject.i_d ? currentProject.i_d && currentProject.i_d.name : '-'"
        />

        <PtoInfoItem
          label-text="Отсутствует смета"
          :text="currentProject.is_no_estimate ? currentProject.is_no_estimate : 'Нет'"
        />

        <PtoInfoItem
          label-text="Без материалов"
          :text="currentProject.is_no_materials ? currentProject.is_no_materials : 'Нет'"
        />

        <PtoInfoItem
          label-text="Стоимость"
          :text="currentProject.price ? priceFormat(currentProject.price) : '-'"
        />
      </ul>

      <ul v-if="currentProject.is_sub_contract"
        class="info__list-edit info__list-edit--col-2"
      >
        <PtoInfoItem
          label-text="Субподрядчик"
          :text="currentProject.sub_contractor ? currentProject.sub_contractor && currentProject.sub_contractor.long_name : '-'"
        />

        <PtoInfoItem
          label-text="% к Ген. подряд"
          :text="currentProject.receive_percent ? priceFormat(currentProject.receive_percent) : '-'"
        />

        <PtoInfoItem
          v-if="currentProject.treaty && currentProject.treaty.treaty_number"
          label-text="Договор с субподрядчиком"
          :text="currentProject.treaty.treaty_number ? currentProject.treaty.treaty_number : '-'"
          is-router-link
          :route="{ name: 'ContractUpdate', params: { id: currentProject.treaty.id } }"
        />
      </ul>

      <AppButtonSmEdit
        v-if="$store.getters.rightsPtoAll && !isEdit"
        class="info__btn-edit"
        title="Редактировать"
        @click.native="toggleIsEdit"
      />
    </div>

    <Form v-model="formDataCheckboxList">
      <div class="checkbox-list">
        <VCheckbox
          v-for="item of checkboxList"
          :key="item.name"
          :title="item.title"
          :name="item.name"
          type="switch"
          :disabled="!isEdit"
        />
      </div>
    </Form>

    <FormPtoProject
      v-if="isEdit"
      :formData="currentProject"
      :is-edit="isEdit"
      :is-sending="isSendingRequest"
      @request="updateCurrentItem"
      @cancel="onCancelEdit"
    />
  </section>
</template>

<script>
import AppButtonSmEdit from '@/components/page/button/AppButtonSmEdit'
import Form from '@/components/page/Form/Form'
import FormPtoProject from '@/components/pto/form/FormPtoProject'
import PtoInfoItem from '@/components/pto/listItem/PtoInfoListItem.vue'
import PtoPriceInfoList from '@/components/pto/list/PtoPriceInfoList'
import VCheckbox from '@/components/page/Form/VCheckbox/VCheckbox'

import { MIXIN_PAGE_DETAIL } from '@/mixins/page/mixinPageDetail'
import { priceFormat } from '@/utils/form/priceFormat'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { getUserFullName } from '@/utils/user'
import { prepareFormDataFromKeyArray } from '@/utils/form/prepareFormDataFromKeyArray'
import { createFormDataFileList } from '@/utils/form/createFormDataFileList'

export default {
  name: 'PtoProjectDetailedProjectUpdate',
  components: {
    AppButtonSmEdit,
    Form,
    FormPtoProject,
    PtoInfoItem,
    PtoPriceInfoList,
    VCheckbox
  },

  mixins: [
    MIXIN_PAGE_DETAIL
  ],

  data: () => ({
    checkboxList: [
      {
        name: 'is_kmd',
        title: 'КМД'
      },
      {
        name: 'is_pvh',
        title: 'Заказы ПВХ'
      },
      {
        name: 'is_cmo',
        title: 'Заказы ЦМО'
      },
      {
        name: 'is_cmk',
        title: 'Заказы ЦМК'
      },
      {
        name: 'is_bru',
        title: 'Заказы БРУ'
      },
      {
        name: 'is_ppr',
        title: 'ППР'
      }
    ],
    formDataCheckboxList: {},
    changes: '-'
  }),

  computed: {
    ...mapGetters('pto/project', {
      currentProject: 'getCurrentItem',
      isLoading: 'getIsLoading'
    }),

    checkboxListMap () {
      return this.checkboxList.map(item => item.name)
    },
    countFiles () {
      return this.currentProject?.files?.length
    },
    textCoExecutors () {
      if (!this.currentProject?.co_executors?.length) return ''

      return this.currentProject.co_executors
        .map(item => getUserFullName(item))
        .join(', ')
    }
  },

  mounted () {
    this.loadOneItem(this.$route.params.projectId)
    this.formDataCheckboxList = prepareFormDataFromKeyArray(this.currentProject, this.checkboxListMap)
  },

  methods: {
    ...mapMutations('pto/project', {
      resetFileListToDelete: 'RESET_FILE_LIST_TO_DELETE'
    }),
    ...mapActions('pto/project', {
      loadOneItem: 'loadOneItem',
      updateItem: 'updateItem',
      requestFile: 'requestFile'
    }),
    getUserFullName,
    priceFormat,

    async updateCurrentItem (data) {
      const formData = {
        ...data,
        ...this.formDataCheckboxList
      }
      const formDataFileList = createFormDataFileList(data.files)

      delete formData.files

      await this.sendPutRequest(formData,
        {
          formDataFileList,
          putDataHasFiles: true
        })
    },

    onCancelEdit () {
      this.toggleIsEdit()
      this.resetFileListToDelete()
      this.formDataCheckboxList = prepareFormDataFromKeyArray(this.currentProject, this.checkboxListMap)
    }
  }
}
</script>
